import { useState } from "react";

// Components
import Header from "components/layout/Header";
import HeaderBanner from "components/layout/HeaderBanner";
import Footer from "components/layout/Footer";
import Stepper from "components/UI/Stepper";
import InfoCollect from "./pages/Insurance-Info/InfoCollect";
import InsuranceSelect from "./pages/Insurance-Select/InsuranceSelect";

// React Router DOM
import { Routes, Route, useLocation } from "react-router-dom";

// Styles
import "./assets/scss/app.scss";

// Redux
import { useSelector } from "react-redux";
import Modal from "components/modals/Modal";

function App() {
  const [modalToggle, setModalToggle] = useState(false);
  const location = useLocation();

  const { bundleData } = useSelector((state: any) => state.bundleData);
  const { formValidity } = useSelector((state: any) => state.formValidity);

  const modalToggleHandler = () => {
    setModalToggle((prevState) => !prevState);
  };

  if (formValidity !== true && location.pathname !== "/") {
    location.pathname = "/";
  }

  return (
    <div className="insurance-app">
      {modalToggle && <Modal modalToggleHandler={modalToggleHandler} />}
      <Header />
      {location.pathname !== "/offers" ? (
        <HeaderBanner />
      ) : (
        <div className="header--spacing"></div>
      )}
      <Stepper step={location.pathname === "/offers" ? 2 : 1} />
      <Routes>
        <Route path="/" element={<InfoCollect />} />
        <Route path="data" element={<InfoCollect />} />
        {formValidity && (
          <Route
            path="offers"
            element={
              <InsuranceSelect
                bundleData={bundleData}
                modalToggleHandler={modalToggleHandler}
              />
            }
          />
        )}
        <Route path="*" element={<InfoCollect />} />
      </Routes>
      {location.pathname === "/" && (
        <Footer bundleData={bundleData} step={1} formValidity={formValidity} />
      )}
    </div>
  );
}

export default App;
